import { useEffect } from 'preact/hooks';
import { Login, TrocarSenhaObrigatoria } from './componentes/Login';
import { Shell } from './componentes/Shell';
import { ColetaApp } from './coleta/ColetaApp';
import { iniciarSessao } from './session';
import { sessaoPronta, usuario } from './state';

export function App() {
  useEffect(() => {
    void iniciarSessao();
  }, []);

  if (!sessaoPronta.value) return <main class="auth"><p class="carregando">Carregando…</p></main>;
  const u = usuario.value;
  if (!u) return <Login />;
  // Em inspeção quem olha é o administrador: a troca de senha pendente da conta inspecionada não o atrapalha (e a API só lê).
  if (u.deveTrocarSenha && !u.inspecionadoPor) return <TrocarSenhaObrigatoria />;

  // O pesquisador usa o app de coleta (celular, funciona sem internet), não o painel agregado.
  // (Inspecionando um pesquisador não se abre o app de coleta: ele mexeria na fila do aparelho. O Shell mostra um resumo.)
  if (u.perfil === 'PESQUISADOR' && !u.inspecionadoPor) return <ColetaApp u={u} />;
  // key: ao entrar/sair de uma inspeção a tela recomeça do zero, sem sobras dos dados da conta anterior.
  return <Shell key={`${u.id}${u.inspecionadoPor ? ':inspecao' : ''}`} />;
}
